import { getFileServiceClient } from "@glideapps/file-service";
import type { ImportTableData } from "./firebase-function-types";

function safeURLCreation(url: string): URL | undefined {
    try {
        return new URL(url);
    } catch (error: unknown) {
        return;
    }
}

export function getFilesForAppCreation(urlFiles: readonly ImportTableData[]): readonly ImportTableData[] {
    return urlFiles
        .map(({ url, displayName }) => ({ url, pathname: safeURLCreation(url)?.pathname ?? "", displayName }))
        .filter(u => u.pathname.endsWith(".csv") || u.pathname.endsWith(".xlsx") || u.pathname.endsWith(".xls"))
        .map(u => ({ url: u.url, displayName: u.displayName }));
}

export async function getSignedURLsAndNamesForFiles(fileIDs: string[]): Promise<readonly ImportTableData[]> {
    const fileServiceClient = getFileServiceClient({
        baseUrl: `/service/file-service`,
        token: undefined,
    });

    try {
        const fileServiceContent = await Promise.all(fileIDs.map(file => fileServiceClient.get(file)));
        return fileServiceContent
            .filter(fs => fs !== undefined)
            .map(fs => ({ url: fs.signedDownloadUrl, displayName: fs.filename }));
    } catch (error: unknown) {
        // We don't want to crash now.
        return [];
    }
}
